export var BankAccountCurrency;
(function (BankAccountCurrency) {
    BankAccountCurrency["RON"] = "RON";
    BankAccountCurrency["AED"] = "AED";
    BankAccountCurrency["AUD"] = "AUD";
    BankAccountCurrency["BGN"] = "BGN";
    BankAccountCurrency["BRL"] = "BRL";
    BankAccountCurrency["CAD"] = "CAD";
    BankAccountCurrency["CHF"] = "CHF";
    BankAccountCurrency["CNY"] = "CNY";
    BankAccountCurrency["CZK"] = "CZK";
    BankAccountCurrency["DKK"] = "DKK";
    BankAccountCurrency["EGP"] = "EGP";
    BankAccountCurrency["EUR"] = "EUR";
    BankAccountCurrency["GBP"] = "GBP";
    BankAccountCurrency["HUF"] = "HUF";
    BankAccountCurrency["INR"] = "INR";
    BankAccountCurrency["JPY"] = "JPY";
    BankAccountCurrency["KRW"] = "KRW";
    BankAccountCurrency["MDL"] = "MDL";
    BankAccountCurrency["MXN"] = "MXN";
    BankAccountCurrency["NOK"] = "NOK";
    BankAccountCurrency["NZD"] = "NZD";
    BankAccountCurrency["PLN"] = "PLN";
    BankAccountCurrency["RSD"] = "RSD";
    BankAccountCurrency["RUB"] = "RUB";
    BankAccountCurrency["SEK"] = "SEK";
    BankAccountCurrency["THB"] = "THB";
    BankAccountCurrency["TRY"] = "TRY";
    BankAccountCurrency["UAH"] = "UAH";
    BankAccountCurrency["USD"] = "USD";
    BankAccountCurrency["XAU"] = "XAU";
    BankAccountCurrency["XDR"] = "XDR";
    BankAccountCurrency["ZAR"] = "ZAR";
})(BankAccountCurrency || (BankAccountCurrency = {}));
